import { render, staticRenderFns } from "./ObrigadoVidasPassadas.vue?vue&type=template&id=c9bffb24"
import script from "./ObrigadoVidasPassadas.vue?vue&type=script&lang=js"
export * from "./ObrigadoVidasPassadas.vue?vue&type=script&lang=js"
import style0 from "./ObrigadoVidasPassadas.vue?vue&type=style&index=0&id=c9bffb24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports